import { Inject, Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Feature, FeatureProperties } from '../../../../projects/client';
import { NO_VALUE } from '../../../shared/pipes';
import { FeatureConnectionService } from '../../../shared/services/feature-connection.service';

import {
  FEATURE_VALUE_STRATEGIES_TOKEN,
  FeatureValueStrategy,
} from './feature-value-strategy.model';

@Pipe({
  name: 'value2',
})
/**This pipe can be used to retrieve value from dc feature, in respect to its status, and DC type,
 * beware that for numbers it returns localized rounded string, so probably not applicable for further chain
 * Types supproted: string, number, boolean
 * No support for schedule, array
 * */
export class Value2Pipe implements PipeTransform {
  constructor(
    private featureConnectionService: FeatureConnectionService,
    @Inject(FEATURE_VALUE_STRATEGIES_TOKEN) private readonly valueStrategies: FeatureValueStrategy[]
  ) {}

  /** Error or not connected status take precedence over any value inside actual feature.
   * This function returns always a string,
   * for numbers, the string is rounded and localised - not applicable for chain
   * */
  transform(
    feature: Feature<FeatureProperties, unknown>,
    propertyName: string,
    customStringForNoValue?: string,
    digitsInfo?: string
  ): string {
    const noValue = customStringForNoValue ?? NO_VALUE;
    const status = feature?.properties?.status?.value;
    const property = feature?.properties?.[propertyName];

    if (
      typeof status === 'string' &&
      this.featureConnectionService.isErrorOrNotConnectedBasedOnValue(status)
    ) {
      return this.featureConnectionService.getTranslatedFeatureStatus(status, noValue);
    }

    if (!property?.value && property?.value !== 0 && property?.value !== false) {
      return noValue;
    }

    if (this.isDcTypeWrong(property.value, property.type, feature.feature)) {
      return noValue;
    }

    const valueStrategy = this.valueStrategies.find((strategy) =>
      strategy.supports(feature, propertyName)
    );

    if (!valueStrategy) {
      return noValue;
    }

    return valueStrategy.transformValue(feature, propertyName, digitsInfo);
  }

  /** maybe we will remove it at somepoint, potential app insights candidate */
  isDcTypeWrong(
    value: string | number | boolean,
    expectedType: string,
    featureName: string
  ): boolean {
    if (environment.env !== 'production' && typeof value !== expectedType) {
      console.error(
        `Alert! ${featureName} has wrong type, expectedType was ${expectedType} but the value was of type ${typeof value}`
      );

      return true;
    }

    return false;
  }
}
